import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Forms from "../../../../Componets/Form";
import toast from "react-hot-toast";
import Header from "../../../../Componets/Header";
import forms from "../../../../Data/Forms/Services/Categories/forms";
import headers from "../../../../Data/Forms/Services/Categories/headers";
import {
  create_service_category,
  get_service_category,
  update_service_category,
} from "../../../../Controllers/Services/Categories";
import Loadercomponent from "../../../../Componets/Loader";

const CategoriesForm = () => {
  let { id } = useParams();

  let navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [values, setValues] = useState(forms);

  const formdata = async (data) => {
    if (data?.status) {
      setButtonLoader(true);

      const category = id
        ? await update_service_category({ id: id, ...data?.data })
        : await create_service_category(data?.data);

      if (category?.status) {
        // if (id) {
        navigate(-1);
        // }
        toast?.success(category?.message);
        setButtonLoader(false);
      } else {
        setButtonLoader(false);
        if (category?.status_code == 403) {
          window.location.href = "/unauthorized";
        } else {
          toast?.error(category?.message);
        }

      }
    }
  };

  const handleData = (category) => {

    let name = category?.name ? category?.name : "";
    let description = category?.description ? category?.description : "";
    let status = category?.status ? category?.status : 0;

    forms[0].options[0].form.value = name;
    forms[0].options[1].form.value = description;
    forms[1].options[0].form.value = status;

    setLoader(false);
    setValues([...values]);
  };

  const fetchData = async () => {
    if (id) {
      setLoader(true);

      const data = {
        id: id,
      };

      const category = await get_service_category(data);

      if (category?.status) {
        handleData(category?.data);
      } else {
        toast?.error(category?.message);
      }
    } else {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Forms
          form={values}
          setForm={setValues}
          formdata={formdata}
          buttonLoader={buttonLoader}
        />
      </Loadercomponent>
    </Header>
  );
};

export default CategoriesForm;
